class PreRegisteredDocument {
  constructor({
    id = '',
    project = '',
    docket_number = '',
    arriving_time = '',
    arriving_date = '',
    start_discharging_time = '',
    mash_control = '',
    specimens_number = '',
    slump = '',
    finish_discharging_time = '',
    detailed_location = '',
    image_name = '',
    mash_control_extra = 0,
    elements = '',
    model = '',
    plant = '',
    manufacture_time = '',
    delivered = 0,
    recipe = '',
    prm_data = null,
  }) {
    this.id = id;
    this.project = project;
    this.docket_number = docket_number;
    this.arriving_time = parseTime(arriving_time);
    this.arriving_date = arriving_date;
    this.start_discharging_time = start_discharging_time;
    this.mash_control = mash_control;
    this.specimens_number = specimens_number;
    this.slump = slump;
    this.finish_discharging_time = parseTime(finish_discharging_time);
    this.detailed_location = detailed_location;
    this.image_name = image_name;
    this.mash_control_extra = mash_control_extra;
    this.elements = elements;
    this.model = model;
    this.plant = plant;
    this.manufacture_time = parseTime(manufacture_time);
    this.delivered = delivered;
    this.recipe = recipe;
    this.prm_data = prm_data;
  }
}

//TODO
const parseTime = (hour) => {
  if (hour) {
    const length = hour.length;
    if (length > 5) hour = hour.substring(0, length - 3);
  }
  return hour;
};

export default PreRegisteredDocument;
